import React$1 from 'react';

const RightArrow = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, /*#__PURE__*/React$1.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React$1.createElement("circle", {
  fill: "#FFF",
  fillRule: "nonzero",
  cx: "20",
  cy: "20",
  r: "20"
}), /*#__PURE__*/React$1.createElement("path", {
  stroke: "#201D1D",
  strokeWidth: "1.5",
  d: "M12 20.13h13.73"
}), /*#__PURE__*/React$1.createElement("path", {
  fill: "#201D1D",
  fillRule: "nonzero",
  d: "M20.76 26.27l-1.02-1.1 5.41-5.04-5.41-5.03 1.02-1.1 6.6 6.13z"
})));

export default RightArrow;
